<template>
    <section class="setting-profile-popup popup-save-document non-app-page-width">
        <div class="setting-profile-wrapper">
            <div class="save-document-form">
                <h2>Page not found.</h2>
                <p>
                    The page you are trying to get to never existed in this reality,<br/>
                    or has migrated to a parallel universe.
                </p>
            </div>
        </div>

    </section>
</template>

<script>
export default {
name: "NotFound"
}
</script>

<style scoped>
</style>

